import StudentsProjectQueueDeleteModal from './students-project-queue-delete-modal'

export default StudentsProjectQueueDeleteModal
